module.exports = __webpack_public_path__ + "img/2024-02-13e_2.5e5ee992.jpg";